import React from 'react';
import { motion } from 'framer-motion';
import { ArrowLeftIcon, UsersIcon, ActivityIcon, TrendingUpIcon, SmartphoneIcon } from 'lucide-react';
interface AdminDashboardProps {
  onBack: () => void;
}
export function AdminDashboard({
  onBack
}: AdminDashboardProps) {
  const stats = [{
    label: 'Total Scans Today',
    value: '142',
    icon: SmartphoneIcon,
    trend: '+12%'
  }, {
    label: 'Active Players',
    value: '28',
    icon: UsersIcon,
    trend: '+4%'
  }, {
    label: 'Avg. Completion Time',
    value: '24m',
    icon: ActivityIcon,
    trend: '-2m'
  }, {
    label: 'Shares Generated',
    value: '86',
    icon: TrendingUpIcon,
    trend: '+24%'
  }];
  return <div className="flex flex-col h-full bg-[#F5F0E8] text-brand-charcoal" data-id="element-96">
      {/* Header */}
      <div className="bg-white pt-6 pb-4 px-6 border-b border-brand-stone/20" data-id="element-97">
        <div className="flex items-center justify-between mb-4" data-id="element-98">
          <button onClick={onBack} className="p-2 bg-brand-cream rounded-full text-brand-charcoal hover:bg-brand-stone/20 transition-colors" data-id="element-99">
            <ArrowLeftIcon className="w-5 h-5" data-id="element-100" />
          </button>
          <div className="text-center" data-id="element-101">
            <span className="text-brand-gold text-[10px] font-bold uppercase tracking-widest block" data-id="element-102">
              Venue Admin
            </span>
            <h2 className="text-lg font-heading text-brand-green-deep" data-id="element-103">
              The Sunset Green
            </h2>
          </div>
          <div className="w-9" data-id="element-104" />
        </div>
      </div>

      <div className="flex-1 overflow-y-auto p-6" data-id="element-105">
        <h3 className="text-2xl font-heading text-brand-green-deep mb-6" data-id="element-106">
          Today's Engagement
        </h3>

        <div className="grid grid-cols-2 gap-4 mb-8" data-id="element-107">
          {stats.map((stat, i) => <motion.div key={stat.label} initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: i * 0.1
        }} className="bg-white p-4 rounded-xl border border-brand-stone/20 shadow-sm" data-id="element-108">
              <div className="flex items-center justify-between mb-3" data-id="element-109">
                <div className="p-2 bg-brand-cream rounded-lg" data-id="element-110">
                  <stat.icon className="w-4 h-4 text-brand-green" data-id="element-111" />
                </div>
                <span className={`text-xs font-bold ${stat.trend.startsWith('+') ? 'text-green-600' : 'text-brand-stone'}`} data-id="element-112">
                  {stat.trend}
                </span>
              </div>
              <div className="text-2xl font-heading text-brand-green-deep mb-1" data-id="element-113">
                {stat.value}
              </div>
              <div className="text-[10px] font-body text-brand-stone uppercase tracking-wider" data-id="element-114">
                {stat.label}
              </div>
            </motion.div>)}
        </div>

        <h3 className="text-xl font-heading text-brand-green-deep mb-4" data-id="element-115">
          Recent Activity
        </h3>
        <div className="bg-white rounded-xl border border-brand-stone/20 shadow-sm overflow-hidden" data-id="element-116">
          {[{
          action: 'Group of 4 finished round',
          time: '2 min ago',
          detail: 'Winner: Sarah K. (Score: 21)'
        }, {
          action: 'New scan at Hole 1',
          time: '5 min ago',
          detail: 'Device: iPhone 14 Pro'
        }, {
          result: true,
          action: 'New Course Record!',
          time: '14 min ago',
          detail: 'Alex M. scored 18'
        }, {
          action: 'Result shared to Instagram',
          time: '15 min ago',
          detail: 'By: Alex M.'
        }, {
          action: 'Group of 2 started round',
          time: '22 min ago',
          detail: 'Mode: Match Play'
        }].map((activity, i) => <div key={i} className="p-4 border-b border-brand-stone/10 last:border-0 flex items-start space-x-3" data-id="element-117">
              <div className={`w-2 h-2 mt-1.5 rounded-full ${activity.result ? 'bg-brand-gold' : 'bg-brand-green/30'}`} data-id="element-118" />
              <div data-id="element-119">
                <p className={`text-sm font-medium ${activity.result ? 'text-brand-gold' : 'text-brand-charcoal'}`} data-id="element-120">
                  {activity.action}
                </p>
                <p className="text-xs text-brand-stone mt-0.5" data-id="element-121">
                  {activity.detail}
                </p>
                <p className="text-[10px] text-brand-stone/60 uppercase tracking-wider mt-1" data-id="element-122">
                  {activity.time}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}